<template>
  <a 
    :href="downloadableFiles[0]?.download_url.original" 
    target="_blank" 
    :class="{'muted': !isActive}" 
    v-if="show && cnt <= 1" 
    @click.stop.prevent="downloadFile"
  >
    <aw-icon icon="download" class="w-5 h-5 "></aw-icon>
    {{$t('Download')}}
  </a>
  <right-menu-item
    v-else-if="show && cnt > 1"
    @click.prevent="downloadZip"
    :class="{ 'muted': !isActive }"
    :text="$t('Download as ZIP')"
    :loading="loading"
    icon="download"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { saveAs } from 'file-saver'
import { FileApi } from '../../test-api/index.ts'
import { trackEvent } from '../../gtm'
import { showAlert } from '../BcAlert'
import { showConfirm } from '../BcConfirm'
import handleApiError from '../../utils/handleApiError'

const fileApi = new FileApi({}, '/api/v2')

export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    show () {
      return true
    },
    isActive () {
      return this.bcSelectedStore.listSelected.length > 0
    },
    downloadableFiles() {
      return this.bcSelectedStore.listSelected
    },
    antivirNotPassedFiles() {
      return this.downloadableFiles.filter((obj) => {
        return (!obj.antivir_ok && !obj.antivir_tested)
      })
    },
    antivirInfectedFiles() {
      return this.downloadableFiles.filter((obj) => {
        return obj.virus_found
      })
    },
    cnt () {
      return this.downloadableFiles.length
    },
    ...mapStores(useBcSelectedStore),
  },
  methods: {
    async downloadZip() {
      if (!await this.avCheck()) {
        return
      }

      this.loading = true
      const requestZipResponse = await handleApiError(() => fileApi.fileRequestZip(
        this.downloadableFiles.map((e) => e.id)
      ))

      saveAs('/api/v2/zip/' + requestZipResponse.data.hash, requestZipResponse.data.file_name + '.zip')
      this.loading = false
      trackEvent(this.$route.matched[0].name, 'downloadZip')
    },
    async avCheck() {
      if (this.antivirInfectedFiles.length) {
        await showAlert({
          header: this.downloadableFiles > 1
            ? this.$t('Cannot download virus infected files.')
            : this.$t('Cannot download virus infected file.'),
        })
        return false
      }

      if (this.antivirNotPassedFiles.length) {
        return await showConfirm({
          header: this.downloadableFiles > 1
            ? this.$t('Do you really want to download antivir untested files?')
            : this.$t('Do you really want to download antivir untested file?'),
          
          text: this.downloadableFiles > 1
            ? this.$t('Some of the selected files haven\'t been tested with antivirus yet.')
            : this.$t('Selected file haven\'t been tested with antivirus yet.'),
        })
      }

      return true
    },
    async downloadFile() {
      if (!await this.avCheck()) {
        return
      }

      saveAs(this.downloadableFiles[0].download_url.original)
      trackEvent(this.$route.matched[0].name, 'downloadFile', this.downloadableFiles[0].id)
    },
  }
}
</script>

<style lang="scss" scoped></style>
